const hamburgerItems = document.getElementsByClassName("hamburger-item");
const hamburgerToggle = document.getElementsByClassName('hamburger-toggle')[0];

export const closeHamburger = () => {
    [...hamburgerItems].forEach(item => {
        item.addEventListener("click", () => hamburgerToggle.checked = false);
    });
}